// removed by extract-text-webpack-plugin
module.exports = {"preview":"button-element-options__preview___ikPDT"};


//////////////////
// WEBPACK FOOTER
// ../stylesheet/css/header-builder/button-element-options.css
// module id = 767
// module chunks = 0